/**
 * THIS FILE IS AUTOMATICALLY GENERATED BY genFonts.js.
 *
 * DO NOT MANUALLY MODIFY THIS FILE.
 */

enum FontClass {
  ArtName = "artNameFont",
  Body1 = "body1Font",
  Body1Bold = "body1BoldFont",
  Body1Medium = "body1MediumFont",
  Body1SemiBold = "body1SemiBoldFont",
  Body2 = "body2Font",
  Body2Bold = "body2BoldFont",
  Body2Medium = "body2MediumFont",
  Body2SemiBold = "body2SemiBoldFont",
  Body3 = "body3Font",
  Body3Bold = "body3BoldFont",
  Body3Medium = "body3MediumFont",
  Body3SemiBold = "body3SemiBoldFont",
  FlashbackHeader0 = "flashbackHeader0Font",
  FlashbackHeader1 = "flashbackHeader1Font",
  FlashbackHeader2 = "flashbackHeader2Font",
  FlashbackHeader3 = "flashbackHeader3Font",
  Header1 = "header1Font",
  Header2 = "header2Font",
  Header3 = "header3Font",
  NavLink = "navLinkFont",
  Price = "priceFont",
  SpotlightTitle = "spotlightTitleFont",
  Subheader = "subheaderFont",
  TinyLabel = "tinyLabelFont",
}

export default FontClass;
